import styled from 'styled-components';
import { ReactNode } from 'react';

export type EllipsisProps = {
  maxLines: number;
  children?: ReactNode;
};

export const Ellipsis = styled.p<EllipsisProps>`
  position: relative;
  overflow: hidden;

  &:after {
    content: '';
    text-align: right;
    position: absolute;
    top: ${({ maxLines }) => (maxLines - 1) * 1.25}em;
    bottom: 0;
    right: 0;
    width: 30%;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1) 80%
    );
  }

  /* Now add in code for the browsers that support -webkit-line-clamp and overwrite the non-supportive stuff */
  @supports (-webkit-line-clamp: ${({ maxLines }) => maxLines}) {
    & {
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${({ maxLines }) => maxLines};
      -webkit-box-orient: vertical;
    }

    &:after {
      display: none;
    }
  }
`;
